export const RatePlanTierApplicationEnum = Object.freeze({
    PROGRESSIVE: 'PROGRESSIVE',
    THRESHOLD: 'THRESHOLD'
});

export default RatePlanTierApplicationEnum;
